// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Card.scss';
import { Link } from 'react-router-dom';
import TimeAgo from '../../../Util/TimeAgo/TimeAgo';

@observer class Card extends Component<any, any> {

	render() {
		return (
			<Link to={'/match/' + this.props.match.id} className="match-card">
				<div className="match-card-info">
					<h2>{this.props.match.participants[0].username} vs {this.props.match.participants[1].username}</h2>
					<p><b>original question:</b> <span title={this.props.match.question.name}>{this.props.match.question.name.substring(0, 30)}{this.props.match.question.name.length >= 30 ? '...' : ''}</span></p>
					<p><b>started: </b><span><TimeAgo date={this.props.match.created_at}/></span></p>
				</div>
			</Link>
		)
	}
}

export default Card;

